export class Promoreturnmodal {
  promoId: string;
  actualAmount: number;
  discountAmount: number;
  amountToBePaid: number;
  licenseCount: number;
  licenseDays: number;
  licenseType: number;
  isValid: boolean;
  returnMessage: string;
  promoName: string;
}
